import { render } from "./IconCustom.vue?vue&type=template&id=4cc6b309"
import script from "./IconCustom.vue?vue&type=script&lang=js"
export * from "./IconCustom.vue?vue&type=script&lang=js"

import "./IconCustom.vue?vue&type=style&index=0&id=4cc6b309&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__